<template>
  <div class="view">
    <div class="title">添加拼团</div>
    <div class="content">
      <div class="set_wrap">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="拼团设置">
            <el-input type="text" placeholder="请输入拼团人数" class="w160"></el-input>人成团
          </el-form-item>
          <el-form-item label="开始结束时间">
            <el-date-picker
              v-model="value1"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="团有效期">
            <el-input type="text" placeholder="请输入团有效期" class="w160"></el-input>小时
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "groupBuyingAddOrEdit",
  data() {
    return {
      form: {
        name: ""
      },
      value1: ""
    };
  },
  methods: {
    onSubmit() {
      // console.log("submit!");
    }
  }
};
</script>